/**
 * Manages the referrer query from the search page.
 * This allows the back button to navigate with the correct query parameter.
 */

const REFERRER_QUERY_KEY = "recommerce_search_page_referrer_query";

/**
 * Store the referrer query in sessionStorage.
 * This should be called when landing on the explore page.
 */
export function setReferrerQuery(query: string): void {
	if (typeof window === "undefined") return;

	try {
		window.sessionStorage.setItem(REFERRER_QUERY_KEY, query);
	} catch (e) {
		console.warn("Failed to store referrer query:", e);
	}
}

/**
 * Retrieve the stored referrer query from sessionStorage.
 * Returns empty string if not found or if sessionStorage is unavailable.
 */
export function getReferrerQuery(): string {
	if (typeof window === "undefined") return "";

	try {
		return window.sessionStorage.getItem(REFERRER_QUERY_KEY) || "";
	} catch (e) {
		console.warn("Failed to retrieve referrer query:", e);
		return "";
	}
}

/**
 * Clear the stored referrer query.
 * Useful when the user starts a new search session.
 */
export function clearReferrerQuery(): void {
	if (typeof window === "undefined") return;

	try {
		window.sessionStorage.removeItem(REFERRER_QUERY_KEY);
	} catch (e) {
		console.warn("Failed to clear referrer query:", e);
	}
}
